import { render, staticRenderFns } from "./promotionV2.vue?vue&type=template&id=03741540&scoped=true&"
import script from "./promotionV2.vue?vue&type=script&lang=js&"
export * from "./promotionV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03741540",
  null
  
)

export default component.exports